import React from 'react'
import { LuBadgeInfo, LuEye, LuFileEdit, LuTrash2, LuEyeOff } from 'react-icons/lu'
import { Tooltip } from 'react-tooltip'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
// import { PopupStatusRes, PopupStatusTodo } from '../../../../redux/slices/Popup/PopupStatus'
import { DeletePopupRes, DeletePopupTodo } from '../../../../redux/slices/popup/DeletePopup'
import { PopupStatusRes, PopupStatusTodo } from '../../../../redux/slices/popup/PopupStatus'

export default function PopupAction(props) {
    const { bool, setBool } = props
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const edit_action = () => {
        navigate('../update-popup', { state: props.data && props.data?.id })
    }
    const del_action = () => {

        Swal.fire({
            title: "Popup Delete",
            text: "Are You Sure Want To Delete This Popup ?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(DeletePopupTodo(props.data.id)).then(() => del_res())
            }

        })
    }

    const del_res = () => {
        if (DeletePopupRes?.success) {
            setBool(!bool)
            Swal.fire(
                "Popup",
                'Popup Deleted Successfully',
                'success'
            )
        } else {
            toast.error(DeletePopupRes?.message, { position: "bottom-right" })
        }
    }
    const status_inactive = () => {

        Swal.fire({
            title: "Popup Inactive",
            text: "Are You Sure Want To Inactive This Popup ?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Inactive'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(PopupStatusTodo({ id: props.data.id, status: 'inactive' })).then(() => ina_res())
            }

        })
    }

    const ina_res = () => {
        if (PopupStatusRes?.success) {
            setBool(!bool)
            Swal.fire(
                "Popup",
                'Popup Inactivate Successfully',
                'success'
            )
        } else {
            toast.error(PopupStatusRes?.message, { position: "bottom-right" })
        }
    }
    const status_active = () => {

        Swal.fire({
            title: "Popup Active",
            text: "Are You Sure Want To Active This Popup ?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Active'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(PopupStatusTodo({ id: props.data.id, status: 'active' })).then(() => act_res())
            }

        })
    }

    const act_res = () => {
        if (PopupStatusRes?.success) {
            setBool(!bool)
            Swal.fire(
                "Popup",
                'Popup Activate Successfully',
                'success'
            )
        } else {
            toast.error(PopupStatusRes?.message, { position: "bottom-right" })
        }
    }
    return (
        <>
            <div>
                {props.data && props.data.popup_status == 'active' ?
                    <LuEyeOff size={20} className='eye text-secondary ms-3'
                        onClick={() => status_inactive()}
                        data-tooltip-id='Inactive'
                        data-tooltip-content="Inactive!"
                        data-tooltip-place="bottom"
                    />
                    :
                    <LuEye size={20} className='eye text-secondary ms-3'
                        onClick={() => status_active()}
                        data-tooltip-id='active'
                        data-tooltip-content="Activate!"
                        data-tooltip-place="bottom"
                    />
                }

                <LuFileEdit size={20} className='edit text-success ms-3'
                    onClick={() => edit_action()}
                    data-tooltip-id='edit'
                    data-tooltip-content="Edit Popup!"
                    data-tooltip-place="bottom"
                />
                {/* <LuBadgeInfo size={20} className='details text-primary ms-3'
        // onClick={() => customer_details()}
        data-tooltip-id='details'
        data-tooltip-content="Customer Details!"
        data-tooltip-place="bottom"
    />*/}
             

                    <LuTrash2 size={20} className='delete text-danger ms-3'
                        onClick={() => del_action()}
                        data-tooltip-id='del'
                        data-tooltip-content="Delete Popup!"
                        data-tooltip-place="bottom"
                    />

                <Tooltip id='edit' className='bg-success tooltip_msg' />
                <Tooltip id='del' className='bg-danger tooltip_msg' />
                <Tooltip id='details' className='bg-primary tooltip_msg' />
                <Tooltip id='active' className='bg-secondary tooltip_msg' />
                <Tooltip id='deactivate' className='bg-secondary tooltip_msg' />

            </div>
        </>
    )
}
